import { render } from "./DeleteJobStackList.vue?vue&type=template&id=e1c1ec52"
import script from "./DeleteJobStackList.vue?vue&type=script&lang=js"
export * from "./DeleteJobStackList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__